export default __webpack_public_path__ + "static/media/book.23a71387.svg";